import './ccf-align-center-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAlignCenterIconProps extends SvgIconProps  {}
/**
 * Component used to display  align center Icon
 * @param props - CcfAlignCenterIconProps
 * @example - <CcfAlignCenterIcon />
 * @returns SVG of align center Icon
 */
export function CcfAlignCenterIcon(props: CcfAlignCenterIconProps) {
  return (
    <SvgIcon {...props}>
        <g id="align_center_icon" data-name="Align Center" transform="translate(3.702 3.702)">
         <path d="M21,15H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm-4,4H7a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2Zm4-8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z" transform="translate(-2 -11)"/>
        </g>
    </SvgIcon>
  );
}

export default CcfAlignCenterIcon;
